export default __webpack_public_path__ + "static/media/loader.d79dc83f.gif";